"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.string.link.js");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _qrcode = _interopRequireDefault(require("qrcode.react"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
// 在这里引入 tea-portal 组件，样式在 style/index.ts 中引入
// import Avatar from '@tencent/tea-portal/lib/Avatar';

// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';
var GenerateQrcode = function GenerateQrcode(props) {
  var className = props.className,
    style = props.style,
    children = props.children,
    _props$link = props.link,
    link = _props$link === void 0 ? '' : _props$link,
    _props$size = props.size,
    size = _props$size === void 0 ? 148 : _props$size,
    _props$fgColor = props.fgColor,
    fgColor = _props$fgColor === void 0 ? '#000000' : _props$fgColor,
    imageSettings = props.imageSettings;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)("generate-qrcode");
  var classes = (0, _classnames.default)(prefixCls, className);
  return /*#__PURE__*/_react.default.createElement(_qrcode.default, {
    id: "qrCode",
    value: link,
    size: size // 二维码的大小
    ,
    fgColor: fgColor // 二维码的颜色
    ,
    style: style,
    imageSettings: imageSettings
  });
};
var _default = GenerateQrcode;
exports.default = _default;